module.exports={Remove:"Eltávolítás"};